<template>
  <AiEducationLayout>
    <div class="ai-edu-admin-page">
      <ContentWrap title="学期校历">
        <el-form :inline="true" :model="query" class="-mb-15px">
          <el-form-item label="学校">
            <el-select
              v-model="query.schoolId"
              class="!w-220px"
              clearable
              filterable
              placeholder="选择学校"
              @change="handleQuery"
            >
              <el-option v-for="s in schools" :key="s.id" :label="s.name" :value="s.id!" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleQuery"><Icon icon="ep:search" />搜索</el-button>
            <el-button
              v-hasPermi="['ai-education:term:write']"
              plain
              type="primary"
              @click="openDialog()"
            >
              <Icon icon="ep:plus" />新增学期
            </el-button>
          </el-form-item>
        </el-form>
      </ContentWrap>
      <ContentWrap>
        <el-table v-loading="loading" :data="list" border>
          <el-table-column prop="name" label="学期名称" min-width="140" />
          <el-table-column prop="code" label="编码" width="120" />
          <el-table-column prop="schoolName" label="学校" min-width="140" />
          <el-table-column prop="startDate" label="开始日期" width="120" />
          <el-table-column prop="endDate" label="结束日期" width="120" />
          <el-table-column prop="enrollStartTime" label="选课开始" width="170" />
          <el-table-column prop="enrollEndTime" label="选课结束" width="170" />
          <el-table-column prop="weekCount" label="周数" width="70" />
          <el-table-column prop="maxCredit" label="学分上限" width="90" />
          <el-table-column prop="examStartDate" label="考试周起" width="120" />
          <el-table-column prop="examEndDate" label="考试周止" width="120" />
          <el-table-column label="状态" width="100">
            <template #default="{ row }">
              <dict-tag :type="DICT_TYPE.AI_EDU_TERM_STATUS" :value="row.status" />
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170" />
          <el-table-column label="操作" width="160" fixed="right">
            <template #default="{ row }">
              <el-button
                v-hasPermi="['ai-education:term:write']"
                link
                type="primary"
                @click="openDialog(row)"
                >编辑</el-button
              >
              <el-button
                v-hasPermi="['ai-education:term:delete']"
                link
                type="danger"
                @click="handleDelete(row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </ContentWrap>

      <Dialog v-model="dialogVisible" :title="form.id ? '编辑学期' : '新增学期'" width="560px">
        <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
          <el-form-item label="学校" prop="schoolId">
            <el-select v-model="form.schoolId" class="w-100%" filterable>
              <el-option v-for="s in schools" :key="s.id" :label="s.name" :value="s.id!" />
            </el-select>
          </el-form-item>
          <el-form-item label="学期名称" prop="name"><el-input v-model="form.name" /></el-form-item>
          <el-form-item label="编码" prop="code"><el-input v-model="form.code" /></el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="form.startDate"
              class="!w-100%"
              type="date"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="form.endDate"
              class="!w-100%"
              type="date"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item label="选课开始">
            <el-date-picker
              v-model="form.enrollStartTime"
              class="!w-100%"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="选课结束">
            <el-date-picker
              v-model="form.enrollEndTime"
              class="!w-100%"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="教学周数">
            <el-input-number v-model="form.weekCount" :min="1" :max="30" class="!w-100%" />
          </el-form-item>
          <el-form-item label="学分上限">
            <el-input-number
              v-model="form.maxCredit"
              :min="0"
              :precision="1"
              :step="0.5"
              class="!w-100%"
            />
            <div class="text-12px text-[var(--el-text-color-secondary)] mt-4px">0 表示不限制</div>
          </el-form-item>
          <el-form-item label="考试周开始">
            <el-date-picker
              v-model="form.examStartDate"
              class="!w-100%"
              type="date"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item label="考试周结束">
            <el-date-picker
              v-model="form.examEndDate"
              class="!w-100%"
              type="date"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" class="w-100%">
              <el-option
                v-for="d in getIntDictOptions(DICT_TYPE.AI_EDU_TERM_STATUS)"
                :key="d.value"
                :label="d.label"
                :value="d.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" /></el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button :loading="saving" type="primary" @click="submit">保存</el-button>
        </template>
      </Dialog>
    </div>
  </AiEducationLayout>
</template>

<script lang="ts" setup>
import * as AiEducationApi from '@/api/aiEducation'
import * as UniversityApi from '@/api/aiEducation/university'
import AiEducationLayout from '../../layout/AiEducationLayout.vue'
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import type { FormInstance, FormRules } from 'element-plus'

defineOptions({ name: 'AiEduTerm' })

const message = useMessage()
const loading = ref(false)
const saving = ref(false)
const list = ref<UniversityApi.TermVO[]>([])
const schools = ref<AiEducationApi.SchoolVO[]>([])
const query = reactive<{ schoolId?: number }>({})
const dialogVisible = ref(false)
const formRef = ref<FormInstance>()
const form = reactive<Partial<UniversityApi.TermVO>>({})
const rules: FormRules = {
  schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
  name: [{ required: true, message: '请输入学期名称', trigger: 'blur' }],
  code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
  startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
  endDate: [{ required: true, message: '请选择结束日期', trigger: 'change' }]
}

const loadSchools = async () => {
  schools.value = (await AiEducationApi.getSchoolList()) || []
}
const load = async () => {
  loading.value = true
  try {
    list.value = (await UniversityApi.getTermList(query.schoolId)) || []
  } finally {
    loading.value = false
  }
}
const handleQuery = () => load()
const openDialog = (row?: UniversityApi.TermVO) => {
  Object.assign(form, {
    id: row?.id,
    schoolId: row?.schoolId ?? query.schoolId,
    name: row?.name || '',
    code: row?.code || '',
    startDate: row?.startDate || '',
    endDate: row?.endDate || '',
    enrollStartTime: row?.enrollStartTime || undefined,
    enrollEndTime: row?.enrollEndTime || undefined,
    weekCount: row?.weekCount ?? 18,
    maxCredit: row?.maxCredit ?? 0,
    examStartDate: row?.examStartDate || undefined,
    examEndDate: row?.examEndDate || undefined,
    status: row?.status ?? 10,
    remark: row?.remark || ''
  })
  dialogVisible.value = true
}
const submit = async () => {
  await formRef.value?.validate()
  saving.value = true
  try {
    await UniversityApi.saveTerm(form)
    message.success('保存成功')
    dialogVisible.value = false
    await load()
  } finally {
    saving.value = false
  }
}
const handleDelete = async (id: number) => {
  await message.delConfirm()
  await UniversityApi.deleteTerm(id)
  message.success('已删除')
  await load()
}

onMounted(async () => {
  await loadSchools()
  await load()
})
</script>
